<template>
    <div class="export-more-files">
        <el-button type="primary" plain icon="el-icon-download" @click="downLoadMb">下载模板</el-button>
        <upload-excel-component style="margin-top: 10px" :on-success="handleImportSuccess" :before-upload="beforeUpload"
            :button-disabled="importLoading" />
        <!-- <el-upload class="upload-demo" :action="uploadImg" name="file" :on-success="handlePosterPreview"
            :headers="headers" drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将excel拖到此处，或<em>点击添加excel</em></div>
        </el-upload> -->
        <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 24px;margin-right: 30px;">
            <!-- <el-button type="primary" plain @click="saveData">确定</el-button> -->
            <el-button type="danger" plain @click="cancelData">取消</el-button>
        </div>
    </div>
</template>
<script>
import host from '@/api/index';
import { formatJson } from '@/utils/utils';
import * as XLSX from 'xlsx';
import UploadExcelComponent from '@/components/UploadExcel/index.vue';
var that = null;
export default {
    name: 'exportMoreFiles',
    props: {
        title: {
            type: String,
            default: ''
        },
        tHeader: {
            type: Array,
            default: () => []
        }
    },
    components: {
        UploadExcelComponent
    },
    data() {
        return {
            importLoading: false
        }
    },
    computed: {
        uploadImg() {
            return host.uploadImgUrl;
        },
        headers() {
            return {
                'bg-token': localStorage.getItem('token') // 直接从本地获取token就行
            };
        }
    },
    mounted() {
        that = this;
    },
    methods: {
        handlePosterPreview(file) {
            console.log(file.data.url);
        },
        // 下载模板
        downLoadMb() {
            const loading = this.$loading({
                text: '正在导出...',
                fullscreen: false
            });
            let rows = [this.tHeader, [], []];
            const sheet = XLSX.utils.aoa_to_sheet(rows);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, sheet, this.title);
            XLSX.writeFile(workbook, this.title + `.xlsx`);
            that.$nextTick(() => {
                loading.close();
            });
        },
        saveData() {
            this.$emit('saveData')
        },
        cancelData() {
            this.$emit('cancelData')
        },
        beforeUpload(file) {
            this.fileName = file.name;
            const isLt1M = file.size / 1024 / 1024 < 3;
            if (isLt1M) {
                return true;
            }
            this.$message({
                message: '文件过大，不要超过3M',
                type: 'error'
            });
            return false;
        },
        handleImportSuccess({ results, header }) {
            if (results.length === 0) {
                this.$message('表中还没有数据哦，请保存或者重新下载后再试。');
            }
            that.importLoading = false;
            console.log(results, header);
            that.$emit('saveData', results, header);
            that.$emit('cancelData');
        }
    }
}
</script>
<style lang="scss" scoped>
.export-more-files {
    .upload-demo {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 24px auto;
    }
}
</style>